import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/standalone-services-page.module.css'
// eslint-disable-next-line import/extensions
import ewaste from '../../json/ewaste-data.json'

const ewasteServiceData = {
  name: 'E-Waste Disposal and IT Asset Disposition',
  description:
    'Enterprise e-waste management nationwide: bulk electronics collection, data destruction, R2-certified recycling, and documented diversion reporting for data centers, offices, and warehouses.',
  serviceType: 'Electronic Waste Recycling',
  url: 'https://getdimension.com/ewaste',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Data Center Decommissioning' },
    { name: 'Bulk Electronics Recycling' },
    { name: 'Hard Drive Data Destruction' },
    { name: 'IT Asset Disposition (ITAD)' },
  ],
}

const ewasteFAQData = {
  questions: ewaste.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' ').replace(/<[^>]*>/g, ''),
  })),
}

function EWaste() {
  return (
    <>
      <Head>
        <title>E-Waste Disposal and IT Asset Disposition | Dimension</title>
        <meta
          name="description"
          content="Enterprise e-waste recycling nationwide. Bulk electronics pickup, hard drive data destruction, and R2-certified recycling, with orders under $2,000 bookable online."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/ewaste" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={ewasteServiceData} />
        <SchemaMarkup type="FAQPage" data={ewasteFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heading={ewaste.pitch.heading}
          material={ewaste.pitch.material}
          pitchText={ewaste.pitch.pitchText}
          ctaLink={ewaste.pitch.ctaLink}
          ctaText={ewaste.pitch.ctaText}
          ctaSubtext="Describe your equipment and our Mirror Mirror AI builds a quote. Orders under $2,000 can be booked online; larger decommissions come back as a reviewed written quote."
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Clients />
        <FeatureList {...ewaste.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...ewaste.benefits} />
        <Approach {...ewaste.approach} />
        <FAQ {...ewaste.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Certified Destruction',
              href: '/certified-destruction',
              description:
                'On-site or off-site destruction of drives, records, and product, with a Certificate of Destruction.',
            },
            {
              label: 'TV and Electronics Removal',
              href: '/tv-electronics-removal',
              description:
                'Single-pickup electronics recycling for households and small offices, priced by the item.',
            },
            {
              label: 'B2B Waste Solutions',
              href: '/b2b-solutions',
              description:
                'Multi-site waste and recycling programs run through one account, one contact, and one set of reporting.',
            },
            {
              label: 'Sustainability Reporting',
              href: '/sustainability',
              description:
                'Diversion data and reporting that turn disposal activity into numbers your ESG team can use.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default EWaste
